<template>
  <div class="main-wrapper blog">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content blog-grid">
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-sm-12 col-md-6 col-lg-4"
            v-for="record in data"
            :key="record.id"
          >
            <!-- Blog -->
            <div class="featured-venues-item">
              <div class="listing-item">
                <div class="listing-img">
                  <router-link
                    :to="`/tin-tuc/${encodeURIComponent(record?.slug)}`"
                  >
                    <img
                      :src="
                        record?.media?.url
                          ? `${url + record.media.url}`
                          : require('@/assets/img/bg/login_bg.jpg')
                      "
                      class="img-fluid"
                      alt="Venue"
                    />
                  </router-link>
                  <div class="fav-item-venues news-sports">
                    <span class="tag tag-blue">{{
                      record?.news_category?.name
                    }}</span>
                  </div>
                </div>
                <div class="listing-content news-content">
                  <h3 class="listing-title blog-title">
                    <router-link
                      :to="`/tin-tuc/${encodeURIComponent(record?.slug)}`"
                      >{{ record?.title }}</router-link
                    >
                  </h3>
                  <div class="short-description">
                    {{ record.short_description }}
                  </div>
                </div>
              </div>
            </div>
            <!-- /Blog -->
          </div>
        </div>
        <!--Pagination-->
        <div class="blog-pagination">
          <nav>
            <ul class="pagination justify-content-center pagination-center">
              <!-- First & Previous Buttons -->
              <li class="page-item previtem" :class="{ disabled: page === 1 }">
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="changePage(1)"
                >
                  <i class="feather-chevrons-left"></i>
                </a>
              </li>
              <li class="page-item previtem" :class="{ disabled: page === 1 }">
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="prevPage"
                >
                  <i class="feather-chevron-left"></i>
                </a>
              </li>

              <!-- Page Numbers -->
              <li v-if="page > 3" class="page-item">
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="changePage(1)"
                  >1</a
                >
              </li>

              <li v-if="page > 4" class="page-item disabled">
                <span class="page-link">...</span>
              </li>

              <li
                v-for="p in visiblePages"
                :key="p"
                class="page-item"
                :class="{ active: p === page }"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="changePage(p)"
                >
                  {{ p }}
                </a>
              </li>

              <li v-if="page < totalPages - 3" class="page-item disabled">
                <span class="page-link">...</span>
              </li>

              <li v-if="page < totalPages - 2" class="page-item">
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="changePage(totalPages)"
                >
                  {{ totalPages }}
                </a>
              </li>

              <!-- Next & Last Buttons -->
              <li
                class="page-item nextlink"
                :class="{ disabled: page === totalPages }"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="nextPage"
                >
                  <i class="feather-chevron-right"></i>
                </a>
              </li>
              <li
                class="page-item nextlink"
                :class="{ disabled: page === totalPages }"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="changePage(totalPages)"
                >
                  <i class="feather-chevrons-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <!--Pagination-->
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import { GET_NEWS_PAGINATE } from "@/graphql/operations/news.ts";
import { useQuery } from "@vue/apollo-composable";
import { computed, ref, watch } from "vue";
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const url = process.env.VUE_APP_SERVER_URL;
    const page = ref(1);
    const pageSize = ref(10);
    const total = ref(1);
    const data = ref([]);
    const authStore = useAuthStore();

    const totalPages = computed(() => {
      return Math.ceil(total.value / pageSize.value);
    });

    const { result } = useQuery(
      GET_NEWS_PAGINATE,
      () => ({
        page: page.value,
        pageSize: pageSize.value,
        filters: {},
      }),
      { fetchPolicy: "network-only" }
    );

    watch(
      result,
      () => {
        data.value = result.value?.news_connection?.nodes;
        total.value = result.value?.news_connection?.pageInfo?.total;
      },
      { deep: true }
    );

    return {
      authStore,
      data,
      url,
      totalPages,
      page,
      pageSize,
      total,
      title: "Tin tức",
      text: "Trang chủ",
      text1: "Tin tức",
    };
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.page = newPage;
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
      }
    },
  },
  computed: {
    visiblePages() {
      let pages = [];
      let start = Math.max(1, this.page - 2);
      let end = Math.min(this.totalPages, this.page + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
};
</script>
<style>
.active > .page-link {
  background: #097e52 !important;
  border-color: #097e52 !important;
  color: #fff !important;
}
</style>
